// In snake_case because these are constant values sent from Backend.
export const EFT_CA = 'eft_ca';
export const EFT_US = 'eft_us';
export const INTERAC = 'interac';
export const STRIPE_EU = 'stripe_eu';
